<template>
<div>
  <el-dialog
      title="更新规则"
      :visible.sync="updateDialog"
      width="930px" >
    <div style="margin-left: 100px" v-loading="updateLoading">
      <el-form label-position="top" :model="ruleItem" :rules="rules" ref="formRef" label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="100px" label="规则名称" prop="name">
              <el-input v-model="ruleItem.name" style="width: 210px" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label-width="100px" label="获得积分" prop="score">
              <el-input-number v-model="ruleItem.score" :min="1" :max="10000"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label-width="100px" label="申请类型" prop="score">
              <el-select v-model="ruleItem.type" placeholder="请选择" style="width: 190px">
                <el-option label="oa申请" :value="0"/>
                <el-option label="集体活动" :value="1"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="100px" label="关联模版">
              <el-cascader style="width: 210px;"   :disabled="ruleItem.type == 1"
                           :options="templateList" v-model="ruleItem.templateList"
                           :props="{value: 'id',label: 'name',children: 'children'}"
                           collapse-tags placeholder="请选择表单类型"
                           clearable  ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label-width="100px" label="有效日期" prop="startAndEndDate">
              <el-date-picker style="width: 80%"
                  v-model="ruleItem.startAndEndDate"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期" @blur="$forceUpdate()">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="21">
            <el-form-item label-width="100px" label="规则说明">
              <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入"
                  v-model="ruleItem.rule">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialog = false">取 消</el-button>
        <el-button type="danger" :disabled="updateLoading" @click="update">确 定</el-button>
      </span>
  </el-dialog>
</div>
</template>

<script>
import { getFormGroups } from "@/api/oa/pages";
import {insertPointsRule} from '/src/api/contacts/hr/pointCard.js'
export default {
  name: "updatedRule",
  data() {
    return {
      updateDialog: false,
      updateLoading: false,
      templateList:[],
      ruleItem: {
        name: "",
        score: 1,
        startAndEndDate:null,
        templateId:null,
        templateList:[],
        startTime:null,
        endTime:null,
        rule:"",
        type:0
      },
      rules: {
        name: [{ required: true, message: "请输入规则名称！", trigger: "blur" }],
        score: [{ required: true, message: "请输入积分！", trigger: "blur" }],
        startAndEndDate: [{ required: true, message: "请选择有效期！", trigger: "blur" }],
      }
    };
  },
  methods:{
    openDialog(item) {
      this.ruleItem = JSON.parse(JSON.stringify(item));
      this.ruleItem.startAndEndDate = [
        this.ruleItem.startTime,
        this.ruleItem.endTime
      ];
      this.updateDialog = true;
      for (const item of this.templateList) {
        for (const form of item.children) {
          let templateId = this.ruleItem.templateId;
          if (form.id === templateId){
            this.ruleItem.templateList = [item.id,templateId];
          }
        }
      }
    },
    update(){
      console.log(this.ruleItem)
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.updateLoading = true;
          this.ruleItem.startTime = this.ruleItem.startAndEndDate[0];
          this.ruleItem.endTime = this.ruleItem.startAndEndDate[1];
          let templateId = this.ruleItem.templateList[1];
          this.ruleItem.templateId = templateId == null ? null:templateId;
          insertPointsRule(this.ruleItem).then(val=>{
            this.updateLoading = false;
            if (val.status == 200){
              this.$emit('refresh');
              this.updateDialog = false;
              this.$notify.success({title: '提示', message: '更新成功！', offset: 40});
              Object.keys(this.ruleItem).forEach((key) => (this.ruleItem[key] = null));
            }else {
              this.$notify.error({title: '更新失败！', message: val.data, offset: 40});
            }
          })
        }
      })
    },

  },
  created() {

    getFormGroups().then(rsp => {
      for (const item of rsp.data) {
        for (const form of item.children) {
          form.id = form.formId;
          form.name = form.formName;
          let templateId = this.ruleItem.templateId;
          if (form.id === templateId){
            this.ruleItem.templateList = [item.id,templateId];
          }
        }
      }
      this.templateList = rsp.data;
    })
  }
}

</script>

<style scoped>

</style>